"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var MarkupRenderer_1 = require("./MarkupRenderer");
var MarkerContentRenderer_1 = require("./MarkerContentRenderer");
var MarkupNodesChildAppender = function (child) { return function (nodes) { return __spreadArrays(nodes.slice(0, -1), nodes
    .slice(-1)
    .map(function (_a) {
    var markup = _a.markup, children = _a.children;
    return ({ markup: markup, children: __spreadArrays(children, [child]) });
})); }; };
var MarkerMarkupNodesOpener = function (_a) {
    var markups = _a.markups;
    return function (_a) {
        var openMarkupIndexes = _a[1];
        return function (nodes) { return __spreadArrays(nodes, openMarkupIndexes.map(function (markupIndex) { return ({
            markup: markups[markupIndex],
            children: []
        }); })); };
    };
};
var MarkupNodesRenderer = function (_a) {
    var createElement = _a.createElement, getMarkupComponent = _a.getMarkupComponent;
    return function (nodes) {
        return nodes.reduceRight(function (innerNode, _a) {
            var markup = _a.markup, children = _a.children;
            return markup
                ? MarkupRenderer_1.default({ createElement: createElement, getMarkupComponent: getMarkupComponent })(markup, __spreadArrays(children, [
                    innerNode
                ]))
                : __spreadArrays(children, [innerNode]);
        }, []);
    };
};
var MarkerMarkupNodesCloser = function (_a) {
    var createElement = _a.createElement, getMarkupComponent = _a.getMarkupComponent;
    return function (_a) {
        var closedMarkupCount = _a[2];
        return function (nodes) {
            return closedMarkupCount
                ? MarkupNodesChildAppender(MarkupNodesRenderer({ createElement: createElement, getMarkupComponent: getMarkupComponent })(nodes.slice(-closedMarkupCount)))(nodes.slice(0, -closedMarkupCount))
                : nodes;
        };
    };
};
exports.default = (function (_a) {
    var createElement = _a.createElement, getAtomComponent = _a.getAtomComponent, getMarkupComponent = _a.getMarkupComponent;
    return function (_a) {
        var markups = _a.markups, atoms = _a.atoms;
        return function (markers) {
            return markers.reduce(function (openMarkups, marker) {
                return utils_1.pipe([
                    MarkerMarkupNodesOpener({ markups: markups })(marker),
                    MarkupNodesChildAppender(MarkerContentRenderer_1.default({ createElement: createElement, getAtomComponent: getAtomComponent })({ atoms: atoms })(marker)),
                    MarkerMarkupNodesCloser({ createElement: createElement, getMarkupComponent: getMarkupComponent })(marker)
                ])(openMarkups);
            }, [{ children: [] }])[0].children;
        };
    };
});
